import React from "react";
import { object } from "prop-types";

import Breadcrumbs from "./bread-crumbs";
import HeroImage from "./hero-image";
import AuthorInfo from "./author-info";
import StoryDate from "./story-date";
import StoryMetaIcons from "./story-meta-icons";
import { DfpComponent } from "../../../ads/dfp-component";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import get from "lodash/get";
import { useSelector } from "react-redux";

import "./story-info.m.css";

const StoryInfo = ({ story }) => {
  if (!story) {
    return null;
  }

  const showLiveIcon = get(story, ["story-template"]) === "live-blog" && !get(story, ["metadata", "is-closed"], false);

  const isStory = story["story-template"] === "photo" || story["story-template"] === "video-2";
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));

  return (
    <div styleName="wrapper">
      <div styleName="basic-info">
        <div styleName={isStory ? "display-style" : ""}>
          <Breadcrumbs story={story} />
        </div>
        <h2 styleName="headline" data-test-id="main-headline">
          {showLiveIcon && (
            <SvgIconHandler type="live-icon" className="live-icon" width="25" height="24" viewBox="0 0 25 24" />
          )}
          {story.headline}
        </h2>
        {story.subheadline && (
          <h3 styleName="sub-headline" data-test-id="sub-headline">
            {story.subheadline}
          </h3>
        )}
      </div>
      <DfpComponent
        adStyleName="ad-slot-size-300x100-leaderboard"
        className="mobile-ad"
        id="story-leader-board-1"
        path={adSlots.story_leader__ad2.ad_unit}
        size={adSlots.story_leader__ad2.sizes}
        viewPortSizeMapping={adSlots.story_leader__ad2.view_port_size_mapping}
      />
      <div>
        <div styleName={isStory ? "display-style" : ""}>
          <HeroImage story={story} />
        </div>
        <AuthorInfo story={story} />
        <StoryDate story={story} />
        <StoryMetaIcons story={story} />
      </div>
    </div>
  );
};

StoryInfo.propTypes = {
  story: object,
};

export default StoryInfo;
